import { Controller } from "@hotwired/stimulus"

// ComunePicker di components/Territorio.js: da 2 lettere, dopo 250 ms, GET /api/geo/comuni?q=; il menu elenca
// «Comune (SIGLA) · Regione». La scelta va nel campo nascosto (la sede in JSON) ed esce con l'evento
// "comune-picker:scelto" (detail.comune; null quando si toglie). Con `aggiunge` il picker resta vuoto dopo la scelta.
export default class extends Controller {
  static targets = ["campo", "scelto", "etichetta", "ricerca", "input", "attesa", "elenco", "vuoto", "voce"]
  static values = { url: { type: String, default: "/api/geo/comuni" }, testId: String, aggiunge: Boolean }

  connect() {
    this.items = []
  }

  disconnect() {
    clearTimeout(this.timer)
    clearTimeout(this.timerChiudi)
  }

  cerca() {
    const text = this.inputTarget.value
    clearTimeout(this.timer)
    if (text.trim().length < 2) {
      this.items = []
      this.chiudi()
      return
    }
    this.timer = setTimeout(async () => {
      this.attesaTarget.hidden = false // span che contiene l'icona: `hidden` su un <svg> non toglie l'attributo
      try {
        const res = await fetch(`${this.urlValue}?q=${encodeURIComponent(text)}`, {
          headers: { Accept: "application/json" }, credentials: "same-origin",
        })
        if (!res.ok) throw new Error(`HTTP ${res.status}`)
        this.items = await res.json()
        this.mostra()
      } catch {
        this.items = []
      } finally {
        this.attesaTarget.hidden = true
      }
    }, 250)
  }

  apri() {
    if (this.items.length) this.mostra()
  }

  chiudiDopo() {
    this.timerChiudi = setTimeout(() => this.chiudi(), 150)
  }

  chiudi() {
    this.elencoTarget.hidden = true
  }

  // l'Invio nel campo non invia il form che lo contiene
  nienteInvio(event) {
    event.preventDefault()
  }

  mostra() {
    const nodi = this.items.length === 0
      ? [this.vuotoTarget.content.firstElementChild.cloneNode(true)]
      : this.items.map((c, i) => {
        const b = this.voceTarget.content.firstElementChild.cloneNode(true)
        b.dataset.testid = `${this.testIdValue}-opt-${c.code}`
        b.dataset.indice = String(i)
        b.prepend(document.createTextNode(`${c.comune} `))
        b.querySelector("[data-dove]").textContent = `(${c.sigla}) · ${c.regione}`
        return b
      })
    this.elencoTarget.replaceChildren(...nodi)
    this.elencoTarget.hidden = false
  }

  // onMouseDown preventDefault dell'originale: il campo non perde il fuoco prima del clic
  trattieni(event) {
    event.preventDefault()
  }

  scegli(event) {
    const c = this.items[Number(event.currentTarget.dataset.indice)]
    this.chiudi()
    this.inputTarget.value = ""
    if (!this.aggiungeValue) this.imposta(c)
    this.dispatch("scelto", { detail: { comune: c } })
  }

  togli() {
    this.imposta(null)
    this.inputTarget.value = ""
    this.dispatch("scelto", { detail: { comune: null } })
  }

  imposta(c) {
    if (this.hasCampoTarget) {
      this.campoTarget.value = c ? JSON.stringify(c) : ""
      this.campoTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
    this.etichettaTarget.textContent = c ? `${c.comune} (${c.sigla}) · ${c.regione}` : ""
    this.sceltoTarget.hidden = !c
    this.ricercaTarget.hidden = !!c
  }
}
